import { render, staticRenderFns } from "./kot-cancellation-modal.vue?vue&type=template&id=2726d351"
import script from "./kot-cancellation-modal.vue?vue&type=script&lang=js"
export * from "./kot-cancellation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports